function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6154 7.15381H4.38462C3.61991 7.15381 3 7.77372 3 8.53842V19.6153C3 20.38 3.61991 21 4.38462 21H19.6154C20.3801 21 21 20.38 21 19.6153V8.53842C21 7.77372 20.3801 7.15381 19.6154 7.15381Z",
  stroke: "#5575FA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.15234 12H16.8447M7.15234 16.1538H16.8447M9.22927 3H14.7677C15.135 3 15.4871 3.14588 15.7468 3.40554C16.0065 3.66521 16.1523 4.01739 16.1523 4.38462V7.15385H7.84465V4.38462C7.84465 4.01739 7.99053 3.66521 8.2502 3.40554C8.50986 3.14588 8.86204 3 9.22927 3Z",
  stroke: "#5575FA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFolderIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolderIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/folder-icon.da6dee76.svg";
export { ForwardRef as ReactComponent };